export const ALL_BASIC_LOGIN_CONFIG = `query($filter: BasicAuthFilter,$first:Int,$last:Int,$after:Cursor,$before:Cursor){
    allBasicAuths(filter:$filter, orderBy:CREATED_AT_DESC,first:$first,last:$last,after:$after,before:$before){
      nodes{
        id
        appName
        basicAuthPath
        isEnabled
        country
        forogtPasswordPath
        resetPasswordPath
        changePasswordPath
        createdAt
        rootPath
        domainName
      }
      totalCount
        pageInfo{
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
    }
  }`;

export const CREATE_BASIC_LOGIN_CONFIG = `mutation($basicAuth:InsertBasicAuthInput!){
    insertBasicAuth(input:$basicAuth)
    {
      basicAuth{
        id
        appName
        basicAuthPath
        isEnabled
        country
        forogtPasswordPath
        resetPasswordPath
        changePasswordPath
        createdAt
        rootPath
        domainName
      }
    }
  }`;

export const UPDATE_BASIC_LOGIN_CONFIG = `mutation($id: UUID!,$appName: String!,$country: String!,$basicAuthPath: String!,$isEnabled: BitString!,
    $forogtPasswordPath: String!, $resetPasswordPath: String!, $changePasswordPath: String!, $basicLoginRootPath: String!, $basicLoginDomainName: String!){
      editBasicAuth(input: {
        basicAuthId:$id,
        app:$appName,
        countryName: $country,
        basicAuthPathName: $basicAuthPath,
        enabled:$isEnabled,
        forogtPasswordPathName: $forogtPasswordPath,
        resetPasswordPathName: $resetPasswordPath,
        changePasswordPathName:$changePasswordPath,
        basicLoginRootPath: $basicLoginRootPath,
        basicLoginDomainName: $basicLoginDomainName
      }){
        basicAuth{
          id
          appName
          country
          isEnabled
          forogtPasswordPath
          resetPasswordPath
          changePasswordPath
          basicAuthPath
          rootPath
          domainName
        }
      }
    }`;

export const DELETE_BASIC_LOGIN_CONFIG = `mutation($id: UUID!){
    deleteBasicAuthById(input:{
      id: $id
    })
    {
      basicAuth{
        id
      }
    }
  }`;
